import { render, staticRenderFns } from "./NumberRangeAlertBehaviorEditor.vue?vue&type=template&id=3a0fbef0&scoped=true&"
import script from "./NumberRangeAlertBehaviorEditor.vue?vue&type=script&lang=ts&"
export * from "./NumberRangeAlertBehaviorEditor.vue?vue&type=script&lang=ts&"
import style0 from "./NumberRangeAlertBehaviorEditor.vue?vue&type=style&index=0&id=3a0fbef0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a0fbef0",
  null
  
)

export default component.exports